import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {clearSelectedInvoices, setSelectedCurrency} from "../../actions/InvoiceActions";
import {CurrencyOption} from "../../reducers/CnbsReducer";

export function CurrencySelector() {
    const currencies = useSelector<any, CurrencyOption[]>(state => state.default.currencyOptions);
    const dispatch = useDispatch();

    function handleSelectCurrency(e: React.ChangeEvent<HTMLSelectElement>) {
        dispatch(setSelectedCurrency(e.target.value));
        dispatch(clearSelectedInvoices());
    }

    useEffect(() => {
        if(currencies.length > 0){
            dispatch(setSelectedCurrency(currencies[0].value));
        }
    }, [currencies]);

    return (<select className={"form-control invoicesHeadingInput"} onChange={handleSelectCurrency}>
        {Array.from(currencies).map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
    </select>);
}


export function useHasMultiCurrency(): boolean{
    const currencies = useSelector<any, CurrencyOption[]>(state => state.default.currencyOptions);
    return currencies?.length > 1;
}